export default {
  props: {
    totalTime: {
      type: Number,
      required: true,
      default: 10
    },
    totalWidth: {
      type: Number,
      required: true,
      default: 0
    },
    secondWidth: {
      type: Number,
      required: false,
      default: 100
    },
    scenesTime: {
      type: Array,
      required: true,
      default: []
    },
    nowTime: {
      type: Number,
      required: true,
      default: 0
    },
    scrollLeft: {
      type: Number,
      required: true,
      default: 0
    },
    limitRight: {
      type: Number,
      required: true,
      default: 0
    },
    isPlay: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      action: '', // 鼠标点击的动作
      indexS: -1, // 选中的简化字幕数组的index值
      simple: [],
      showAddBtn: true,
      limitLeft: 178,
      mpos: {
        x: 0,
        nowTime: 0
      },
      limitActionMove: false,
      limitActionFrame: null,
      saveComponent: {}
    }
  },
  watch: {
    isPlay(val, oldval) {
      if(!val && oldval) {
        this.checkAdd()
      }
    },
    nowTime() {
      if(this.isPlay) return;
      this.checkAdd();
    }
  },
  mounted() {
    this.initData();
    this.saveComponent = this;
    // console.log('this.saveComponent', this.saveComponent);
  },
  methods: {
    checkAdd(startTime = this.nowTime) {
      let limit = this.totalTime;
      let s = null;
      // []
      for(let i = 0; i < this.simple.length; i++) {
        s = this.simple[i];
        if(startTime < s.start) {
          if(s.start - startTime > 0.2) {
            this.showAddBtn = true;
          } else {
            this.showAddBtn = false;
          }
          return i
        } else if (startTime < s.end) {
          this.showAddBtn = false;
          return i
        }
      }
      if(limit - startTime > 0.2) {
        this.showAddBtn = true;
      } else {
        this.showAddBtn = false;
      }
      return this.simple.length;
    },
    mouseDown(action, dx, index) {
      if(!action) {
        this.setSelectIndex(-1);
        return;
      }
      if(action === 'ruler') {
        let dt = (this.scrollLeft + dx - 10 - this.limitLeft) / this.secondWidth;
        this.$emit('changeNowTime', dt);
        this.setSelectIndex(-1);
        this.mpos.nowTime = this.nowTime;
        return;
      }
      if(!index) return;
      this.setSelectIndex(+index);
      if (this.$store.getters['addSoundtrack/getPlayHandle'].musicLoop && this.saveComponent.$refs['sound-timeline']) {
        // 循环状态下禁止拖动
        return;
      }
      let m = this.simple[this.indexS];
      this.action = action;
      this.mpos.x = dx;
      this.mpos.nowTime = this.nowTime;
      if(action === 'move') {
        if (this.simple[this.indexS - 1]) {
          this.mpos.ml = this.simple[this.indexS - 1].end;
        } else {
          this.mpos.ml = 0;
        }
        if (this.simple[this.indexS + 1]) {
          this.mpos.mr = this.simple[this.indexS + 1].start;
        } else {
          this.mpos.mr = this.totalTime;
        }
      } else if (action === "left") {
        if (this.simple[this.indexS - 1]) {
          this.mpos.ml = this.simple[this.indexS - 1].end;
        } else {
          this.mpos.ml = 0;
        }
        if(m.long && m.end - m.long > this.mpos.ml) {
          this.mpos.ml = m.end - m.long;
        }
        this.mpos.mr = m.end - 0.2;
      } else if (action === 'right') {
        if (this.simple[this.indexS + 1]) {
          this.mpos.mr = this.simple[this.indexS + 1].start;
        } else {
          this.mpos.mr = this.totalTime;
        }
        if(m.long && m.start + m.long < this.mpos.mr) {
          this.mpos.mr = m.start + m.long;
        }
        this.mpos.ml = m.start + 0.2;
      }

      this.mpos.l = m.start;
      this.mpos.r = m.end;
      this.mpos.d = m.dura;
      this.mpos.scroll = this.scrollLeft;
      this.mpos.dx = (dx + this.scrollLeft - this.limitLeft - 10) / this.secondWidth - m.start;
    },
    mouseMove(dx){
      if(!this.action) return;
      let change = 0,
      cl = this.mpos.l,
      cr = this.mpos.r;

      if(dx >= this.limitRight) {
        this.limitAction(1, this.action, this.mpos);
      } else if(dx <= this.limitLeft) {
        this.limitAction(-1, this.action, this.mpos);
      } else {
        this.cancelLimitAction(this.action, dx)
        change = (dx - this.mpos.x) / this.secondWidth;
        cl = this.mpos.l + change;
        cr = this.mpos.r + change;
        this.mpos.change = change;
        this.boxChange(this.action, cl, cr);
      }
    },
    mouseUp() {
      this.cancelLimitAction();
      if(this.mpos.nowTime !== this.nowTime) {
        this.$emit('initScencePlay')
      }
      if(!this.action) return;
      if(this.mpos.change) {
        this.changeSelect();
      }
      this.mpos = {};
      this.action = "";
    },
    boxChange(action, cl, cr) {
      let stop = false;
      if(action === 'move') {
        for (let i in this.scenesTime) {
          if(Math.abs(cl - this.scenesTime[i]) < 0.1) {
            cl = this.scenesTime[i];
            cr = cl + this.mpos.d;
            break;
          }
          if (Math.abs(cr - this.scenesTime[i]) < 0.1) {
            cr = this.scenesTime[i];
            cl = cr - this.mpos.d;
            break;
          }
        }
        if (cl < this.mpos.ml) {
          cl = this.mpos.ml;
          cr = cl + this.mpos.d;
          stop = true;
        }
        if (cr > this.mpos.mr) {
          cr = this.mpos.mr;
          cl = cr - this.mpos.d;
          stop = true;
        }
      } else if(action === 'left') {
        for (let i in this.scenesTime) {
          if (Math.abs(cl - this.scenesTime[i]) < 0.1) {
            cl = this.scenesTime[i];
            break;
          }
        }
        cr = this.mpos.r;
        if (cl < this.mpos.ml) {
          cl = this.mpos.ml;
          stop = true;
        } else if (cl > this.mpos.mr) {
          cl = this.mpos.mr;
          stop = true;
        }
      } else if(action === 'right') {
        for (let i in this.scenesTime) {
          if (Math.abs(cr - this.scenesTime[i]) < 0.1) {
            cr = this.scenesTime[i];
            break;
          }
        }
        cl = this.mpos.l;
        if (cr < this.mpos.ml) {
          cr = this.mpos.ml;
          stop = true;
        } else if (cr > this.mpos.mr) {
          cr = this.mpos.mr;
          stop = true;
        }
      }

      this.simple[this.indexS].start = cl;
      this.simple[this.indexS].end = cr;
      this.simple[this.indexS].dura = cr - cl;
      return stop;
    },
    limitAction(dire, action, mpos){
      if(this.limitActionMove) return;
      this.limitActionMove = true;

      let start = null,
        startNode = dire === 1 ? this.limitRight - mpos.x : this.limitLeft - mpos.x,
        step = null,
        change = 0,
        cl = mpos.l,
        cr = mpos.r,
        ds = 0,
        stop = false;

      step = timestamp => {
        if (!start) start = timestamp;
        ds = ((dire * (timestamp - start)) / 200) * this.secondWidth;
        change = (ds + startNode) / this.secondWidth;
        cl = mpos.l + change;
        cr = mpos.r + change;
        stop = this.boxChange(action, cl, cr);
        if(stop) {
          window.cancelAnimationFrame(this.limitSubtitleFrame);
          return;
        }
        mpos.change = change;
        ds = ds + mpos.scroll;
        this.$emit('changeScrollLeft', ds);
        this.limitActionFrame = window.requestAnimationFrame(step);
      }

      this.limitActionFrame = window.requestAnimationFrame(step);
    },
    cancelLimitAction(action, dx) {
      if(this.limitActionMove) {
        window.cancelAnimationFrame(this.limitActionFrame);
        this.limitActionMove = false;
        if(dx) {
          // 回到正常拖动后的mousedown初始值更改
          let disxT, cl, cr;
          this.mpos.scroll = this.scrollLeft;
          // 算出鼠标回归正常后的位置对应的时间
          disxT = (this.scrollLeft + dx - this.limitLeft - 10) / this.secondWidth;
          // 计算出鼠标回归后的字幕块的位置和大小
          if (action === "move") {
            // 可能字幕快很大，不能简单的定位在中心位置，而是用开始计算好的距离start位置的差值dx
            cl = disxT - this.mpos.dx;
            cr = cl + this.mpos.d;
          } else if (action === "left") {
            // 直接定位到边缘区域（left区域本身就很小）
            cl = disxT;
          } else if (action === "right") {
            cr = disxT;
          }
          // 判断对应的位置是否有超过极限（也就是条件判断条件后的字幕快位置，大小）
          this.boxChange(action, cl, cr);
          // 修改mousedown初始化的字幕信息（对应这次鼠标回归的位置）
          this.mpos.l = this.simple[this.indexS].start;
          this.mpos.r = this.simple[this.indexS].end;
          this.mpos.d = this.simple[this.indexS].dura;
          // 然后根据字幕快的位置大小计算出鼠标应该在什么位置
          if (action === "move") {
            this.mpos.x =
              (this.mpos.l + this.mpos.dx) * this.secondWidth -
              this.scrollLeft +
              this.limitLeft +
              10;
          } else if (action === "left") {
            this.mpos.x =
              this.mpos.l * this.secondWidth -
              this.scrollLeft +
              this.limitLeft +
              10;
          } else if (action === "right") {
            this.mpos.x =
              this.mpos.r * this.secondWidth -
              this.scrollLeft +
              this.limitLeft +
              10;
          }
          // 以上逻辑终结为  鼠标 -> 字幕快（应该） -> 字幕快（实际） -> 鼠标
        }
      }
    },
    settingPanel(i, type) {
      if( i > -1 ) {
        this.$store.commit("addSoundtrack/setSoundtrackState", {
          type: type
        });
      } else {
        this.$store.commit("addSoundtrack/setSoundtrackState", {
          type: 'noSet'
        });
      }
    }
  },
  directives: {
    drag(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        action = '',
        index = -1;

      mousemove = e => {
        e.preventDefault();

        _this.mouseMove(e.pageX);
      };

      mouseup = e => {
        e.preventDefault();
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.mouseUp(e.pageX);
      };

      el.onmousedown = e => {
        e.preventDefault();
        action = e.target.dataset.action;
        index = e.target.dataset.index;
        _this.mouseDown(action, e.pageX, index);
        if(!action) return;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };

      el.oncontextmenu = () => {
        return false;
      };
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/timelineContent/timelineMixins.js